import React, { useState } from 'react';
import { Tabs } from 'antd';
import { CommentList } from '../../Comment';
import { Comment, CommentProps } from '../../Comment/Comment';
import SpecDrawer from '../../SpecDrawer/SpecDrawer';
import { XIcon } from '../../icons';
import ProfileSection from './ProfileSection';
import '../Profile.css';

export interface ShowCommentsSectionProps {
  comments: Omit<CommentProps, 'className'>[];
  maxComments?: number;
  showEventInfo?: boolean;
}

export const ShowCommentsSection: React.FC<ShowCommentsSectionProps> = ({
  comments,
  maxComments = 3,
  showEventInfo = false,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('upcoming');

  if (comments.length === 0) return null;

  const commentsWithEventInfo = showEventInfo
    ? comments.map(c => ({ ...c, showEventInfo: true }))
    : comments;

  const renderCommentList = (items: Omit<CommentProps, 'className'>[]) => (
    <div className="view-all-drawer__comment-list">
      {items.length === 0 ? (
        <div className="view-all-drawer__empty">No comments yet</div>
      ) : (
        items.map((comment, i) => <Comment key={i} {...comment} />)
      )}
    </div>
  );

  const customTitle = (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', position: 'relative' }}>
      <div
        style={{
          width: '40px',
          height: '4px',
          background: 'rgba(255, 255, 255, 0.3)',
          borderRadius: '2px',
          margin: '0 auto 24px',
          flexShrink: 0,
        }}
      />
      Show Comments
      <div
        style={{
          position: 'absolute',
          right: 0,
          top: '8px',
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <button onClick={() => setDrawerOpen(false)} aria-label="Close drawer" className="drawer-close-button">
          <XIcon size="m" tone="white" />
        </button>
      </div>
    </div>
  );

  return (
    <ProfileSection title="Show Comments">
      <CommentList
        comments={commentsWithEventInfo}
        maxComments={maxComments}
        onViewAll={() => setDrawerOpen(true)}
      />
      <SpecDrawer
        title={customTitle}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        size="large"
        swipeable={false}
        closable={false}
        zIndex={1100}
      >
        <div className="view-all-drawer__content">
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            centered
            items={[
              { key: 'upcoming', label: 'Upcoming', children: renderCommentList(commentsWithEventInfo) },
              { key: 'past', label: 'Past', children: renderCommentList(commentsWithEventInfo) },
            ]}
          />
        </div>
      </SpecDrawer>
    </ProfileSection>
  );
};

export default ShowCommentsSection;
